import Header from "../../components/Header";
import * as S from "./style";

const House = () => (
  <>
    <Header />
  </>
);

export default House;
